
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/zaciatok-lyziarskej-sezony-predpoklad",
      function () {
        return require("private-next-pages/[region]/zaciatok-lyziarskej-sezony-predpoklad.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/zaciatok-lyziarskej-sezony-predpoklad"])
      });
    }
  